import { render, staticRenderFns } from "./CommandesItem.vue?vue&type=template&id=7bb13f97&"
import script from "./CommandesItem.vue?vue&type=script&lang=js&"
export * from "./CommandesItem.vue?vue&type=script&lang=js&"
import style0 from "./CommandesItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports